import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { user } from '@/components/User.js';


export function runAjaxLoaderTimer() {
    const ajaxLoaderTimer = setInterval(() => {
        const loaderElement = document.querySelector('.ajax-loader');
        if (loaderElement.hasAttribute('display-time')) {
            let displayTimeSeconds = +loaderElement.getAttribute('display-time');
            if (displayTimeSeconds > 60) {
                swal({
                    text: `Нет соединения`,
                    icon: "error",
                }).then(() => {
                    loader.hide();
                    user.destroy();
                    document.cookie = 'PHPSESSID' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                    interval.clearAll();
                    m.route('/login');
                });
                clearInterval(ajaxLoaderTimer);
            } else {
                loaderElement.setAttribute('display-time', displayTimeSeconds + 1);
            }
        }
    }, 1000);
}
